"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = require("styled-components");

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Theme
const BaseButton = (0, _styledComponents.css)(["display:inline-flex;align-items:center;font-family:", ";font-size:1rem;font-weight:", ";text-decoration:none;text-align:center;color:", ";border-color:", ";border-width:1px;border-style:solid;border-radius:", ";background:transparent;padding:0 1rem;height:2.5rem;transition-duration:0.5s;&:hover{cursor:pointer;color:", ";border-color:", ";}"], _BaseTheme.default.type.family.system, _BaseTheme.default.type.weight.regular, _BaseTheme.default.colors.gray, _BaseTheme.default.colors.bluegray, _BaseTheme.default.radius.regular, _BaseTheme.default.colors.black, _BaseTheme.default.colors.gray);
var _default = BaseButton;
exports.default = _default;